import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

export interface IIntegrationUserMapPatch {
	providerId: string;
	userId: string | null;
}

export const usePatchExternalIntegrationUserMapsMutation = ({
	impersonationContext,
	onError,
	onSuccess,
}: {
	impersonationContext?: Api.IImpersonationContext;
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: (updated: Api.IIntegrationUser[]) => void;
} = {}) => {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: ({
			integrationProvider,
			patches,
		}: {
			integrationProvider: Api.IntegrationProvider;
			patches: IIntegrationUserMapPatch[];
		}) =>
			userSession.webServiceHelper.callAsync<Api.IIntegrationUser[]>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: `integrations/${integrationProvider}/userMaps`,
				}),
				'PATCH',
				patches
			),
		onError,
		onSuccess,
	});
};
